import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ApiKeyAccessAdminDto} from '../../dtos/apiKeyAccessAdmin.dto';

/**
 * Reads and decides the api key access of an account.
 * The acting person is never sent from here: the backend takes it from the session, which is why
 * both posts carry an empty body.
 * No error handling and no retry here on purpose, so the refusal is handled in exactly one place.
 */
@Injectable({
    providedIn: 'root'
})
export class ApiKeyAccessAdminService {

    constructor(private httpClient: HttpClient) {
    }

    public get(accountCode: string): Observable<ApiKeyAccessAdminDto> {
        return this.httpClient.get<any>(this.url(accountCode))
            .pipe(map(data => {
                return new ApiKeyAccessAdminDto().deserialize(data);
            }));
    }

    public grant(accountCode: string): Observable<ApiKeyAccessAdminDto> {
        return this.httpClient.post<any>(this.url(accountCode) + '/grant', null)
            .pipe(map(data => {
                return new ApiKeyAccessAdminDto().deserialize(data);
            }));
    }

    public withdraw(accountCode: string): Observable<ApiKeyAccessAdminDto> {
        return this.httpClient.post<any>(this.url(accountCode) + '/withdraw', null)
            .pipe(map(data => {
                return new ApiKeyAccessAdminDto().deserialize(data);
            }));
    }

    private url(accountCode: string): string {
        return environment.apiUrl + 'api/accounts/admin/v1/apiKeyAccess/' + encodeURIComponent(accountCode);
    }
}
